export const shopLinkRegex = /^[a-zA-Z0-9-_.\u0E00-\u0E7F]*$/;
export const identityRegex = /^[0-9]{13}$/;
export const dateRegex = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/; // dd/mm/yyyy
export const specialCharacterRegex = /[0-9!@#$%^&*()_+\-=\[\]{​}​;':"\\|,.<>\/?]/;
export const nonThaiRegex = /[^ก-๙|\s]/;
export const nonEnglishRegex = /[^a-zA-Z|\s]/;
export const mobileNumRegex = /^0[0-9]{9}$/;
export const formattedMobileNumRegex = /\d{3}-\d{3}-\d{4}$/;
export const passportRegex = /^[a-zA-Z0-9]+$/;

